enum VersionRoutesAPI {
  VERSION_FILE_DOWNLOAD = '/customer-portal-service/Version/File/:fileId',
}

enum VersionRoutesApplication {
  VERSION_LIST = '/application/version',
  VERSION_FILE_LIST = '/application/version/:versionId',
}

export {
  VersionRoutesAPI,
  VersionRoutesApplication,
};
